import YesIcon from 'assets/images/yes-icon.svg';

import QuoteLeft from 'assets/images/quote-left.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/logo-footer.png';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = 'killeen_subscriber',
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Killeen Family Dentistry',
  tokenName: 'killeenSubscriberToken',
  globalClass: 'killeen-container',
  clientHeader,
  pricingType: 'standard-pricing',
  headerProps: {
    align: 'center',
  },
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      subTitleClasses: 'text-highlight',
      primaryButtonProps: {},
      heroImage: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      variant: 1,
      alignCard: 'left',
    },
    subscriptionSection: {},
    howItWorksSection: {
      heroImage: '/images/home-images/how-it-works.webp',
    },
    testimonialSection: {
      variant: 1,
      heroImage: '/images/home-images/testimonial.webp',
      quoteImage: QuoteLeft,
      messageType: 'h6',
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  checkoutSection: {},
  savingsSummary: {},
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: false,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    logo: FooterLogo
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme
};

export default config;